<template>
  <div>
    <head-nav-bar title="订单详情" :fixed="true">
      <template slot="right">
        <van-dropdown-menu>
          <van-dropdown-item title="…" ref="item">
            <van-cell-group class="order-drop-menu">
              <van-cell
                title="订单日志"
                is-link
                @click="
                  $router.push({
                    name: 'GroupOrderLog',
                    query: { id: orderId, companyId: companyId },
                  })
                "
              />
            </van-cell-group>
          </van-dropdown-item>
        </van-dropdown-menu>
      </template>
    </head-nav-bar>
    <div class="mt-header-nav">
      <div class="info-box">
        <van-row class="title">
          <van-col span="12"> 订单信息 </van-col>
          <van-col span="12" class="amount">
            <van-tag type="danger" v-if="orderInfo.Status == '4'"
              >已取消</van-tag
            >

            <van-tag
              type="success"
              style="margin-right:2px"
              v-else-if="orderInfo.Status == '2'"
              >已完成</van-tag
            >
            待收金额：<span class="amountColor">
              {{ orderInfo.NeedToPayAmount }}
            </span>
          </van-col>
        </van-row>
        <van-row class="contact">
          <van-col span="19">
            {{ orderInfo.Contact }}
            <span class="phone"
              >{{ orderInfo.Phone ? orderInfo.Phone : "未留电话" }}
              {{ orderInfo.PhoneLocation }}</span
            >
            <!-- <span class="address">江西南昌</span> -->
          </van-col>
          <van-col span="5" class="text-right">
            <!-- <van-icon
              :name="contactIcon"
              size="20"
              :class="{ contacted: orderInfo.HasContacted }"
              style="margin-right: 10px;"
              @click="ContactGuest(orderInfo.HasContacted)"
            /> -->
            <van-icon
              name="phone"
              size="21"
              v-if="orderInfo.Phone"
              @click="onCall(orderInfo.Phone)"
            />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="8">
            <label> 订单编号：</label><span>{{ orderInfo.OrderNo }}</span>
          </van-col>
          <van-col span="8">
            <label> 渠道：</label><span>{{ orderInfo.ChannelName }}</span>
          </van-col>
          <van-col span="8">
            <label> 业务员：</label><span>{{ orderInfo.SalesmanName }}</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="8">
            <label> 客户：</label><span>{{ orderInfo.CustomerName }}</span>
          </van-col>
          <van-col span="8">
            <label>会员卡：</label><span>{{ orderInfo.MemberName }}</span>
          </van-col>
          <van-col span="8">
            <label>价类：</label><span>{{ orderInfo.PriceCodeName }}</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <label> 备注：</label>
            <span class="remark">
              {{ orderInfo.ContactRemark }}
            </span>
          </van-col>
        </van-row>
      </div>
      <div class="info-box">
        <van-row class="title">
          <van-col span="14">
            房间信息
            <small style="color:#333;margin-left:10px;font-weight:bold"
              >预计房费：<em style="color:#f00;font-size:14px">{{
                orderInfo.OrderTotalRoomPrice
              }}</em></small
            ></van-col
          >
          <van-col span="10" class="amount">
            消费金额：
            <span class="amountColor">{{ orderInfo.TotalAmount }}</span>
          </van-col>
        </van-row>
        <div style="height: 150px;overflow: auto;">
          <div
            v-for="(item, index) in orderInfo.Details"
            :key="index"
            class="room-content"
          >
            <van-row class="room-item">
              <van-col span="13" class="name">
                {{ item.RoomTypeName }}-{{
                  item.RoomNo ? item.RoomNo : "未排房"
                }}
              </van-col>
              <van-col span="4">
                {{ item.TotalRoomPrice }}
              </van-col>
              <van-col span="4">
                <van-tag plain type="primary">
                  证件*{{ item.IDCardCount }}
                </van-tag>
              </van-col>
              <van-col span="3" class="status"> {{ item.StatusName }} </van-col>
            </van-row>
            <van-row class="check-date">
              <van-col span="10">
                住店:<span>
                  {{
                    orderInfo.IsHourRoom ? item.CheckInTime : item.CheckInDate
                  }}
                </span>
              </van-col>
              <van-col span="10">
                {{ item.OrderStatus == 2 ? "离店" : "预离" }}:<span>
                  {{
                    orderInfo.IsHourRoom ? item.CheckOutTime : item.CheckOutDate
                  }}
                </span>
              </van-col>
              <van-col span="4">
                共
                <em style="color:#f00;font-style:normal">{{ item.diffDay }}</em>
                晚
              </van-col>
            </van-row>
            <van-collapse
              class="consume-detail"
              v-model="activeNames"
              v-if="item.Consumes.length > 0"
              :border="false"
            >
              <van-collapse-item title="消费明细" :name="1 + index">
                <div class="amount" slot="value">
                  <span style="color:#f00;">{{ item.total }}</span>
                </div>
                <table>
                  <tr>
                    <th>项目</th>
                    <th>单价</th>
                    <th>单据号</th>
                    <th>日期</th>
                    <th>金额</th>
                  </tr>
                  <tbody>
                    <tr v-for="(item1, index1) in item.Consumes" :key="index1">
                      <td>{{ item1.AccountItemName }}*{{ item1.Quantity }}</td>
                      <td>{{ item1.UnitPrice }}</td>
                      <td>{{ item1.BillNo }}</td>
                      <td>{{ item1.AccountDate }}</td>
                      <td>{{ item1.TotalPrice }}</td>
                    </tr>
                  </tbody>
                </table>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
      <div class="info-box">
        <van-collapse
          class="consume-detail pay-detail"
          v-model="payActiveNames"
          :border="false"
        >
          <van-collapse-item title="收付款信息" name="1">
            <div class="amount" slot="value">
              已收金额：<span class="amountColor">{{
                orderInfo.AlreadyPayAmount
              }}</span>
            </div>
            <table>
              <tr>
                <th width="20%">付款方式</th>
                <th width="15%">单据号</th>
                <th width="25%">客户/会员</th>
                <!-- <th>备注</th> -->
                <th>日期</th>
                <th width="15%">金额</th>
              </tr>
              <tr v-for="(item, index) in orderInfo.Pays" :key="index">
                <td>{{ item.AccountItemName }}</td>
                <td>{{ item.BillNo }}</td>
                <td>{{ item.TargetName }}</td>
                <!-- <td>{{ item.AccountRemark }}</td> -->
                <td>{{ item.AccountDate }}</td>
                <td>{{ item.TotalPrice }}</td>
              </tr>
            </table>
          </van-collapse-item>
        </van-collapse>
      </div>
      <van-goods-action>
        <template slot="default">
          <van-row style="width:100%" :gutter="1">
            <van-col span="8">
              <van-button
                type="info"
                :disabled="!isShowEdit"
                size="large"
                @click="updateOrder"
              >
                修改订单
              </van-button>
            </van-col>
            <van-col span="8">
              <van-button
                :disabled="!isShowCancel || orderInfo.Status != 0"
                type="info"
                size="large"
                @click="orderCancle"
              >
                取消订单
              </van-button>
            </van-col>
            <van-col span="8">
              <van-button
                :disabled="orderInfo.Status != 4"
                type="info"
                size="large"
                @click="orderRecover"
              >
                恢复订单
              </van-button>
            </van-col>
          </van-row>
        </template>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import groupOrderApi from "../../api/group_order.js";
import { jump } from "../../utils/common";
import { mapState, mapActions } from "vuex";
import cloneDeep from "lodash/cloneDeep";
// import { getSelectData } from "@/api/common.js";
import {
  tag,
  Row,
  Col,
  Icon,
  Collapse,
  CollapseItem,
  GoodsAction,
  Button,
  Dialog,
  // Toast,
  Notify,
  DropdownMenu,
  DropdownItem,
  CellGroup,
  Cell,
} from "vant";
export default {
  name: "OrderDetail",
  components: {
    [tag.name]: tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [GoodsAction.name]: GoodsAction,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      params: {},
      orderId: null,
      // contactIcon: "star-o",
      activeNames: ["0"], //消费明细展开项
      payActiveNames: ["1"], //收付款展开项
      orderInfo: {},
      isShowCancel: true, //订单中包含已完成的明细，则不能整单取消
      isShowEdit: false, //是否显示修改
      // total: {
      //   orderMoney: 0, //待收金额
      //   roomMoney: 0, //房间消费金额
      //   paymoney: 0 //已收金额
      // }
      companyId: "",
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.companyId = this.$route.query.companyId;
    this.params = {
      Id: this.orderId,
      CompanyId: this.companyId,
    };
    this.getOrderDetail();
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    ...mapActions(["setRoomInfo"]),
    getOrderDetail() {
      groupOrderApi.GetGroupOrderDetail(this.params).then(res => {
        this.orderInfo = res.Data;
        this.orderInfo.Pays.forEach(ele => {
          ele.AccountDate = moment(ele.AccountDate).format("YYYY-MM-DD");
        });
        this.orderInfo.Details.forEach(item => {
          let total = 0;
          item.Consumes.forEach(el => {
            total += Number(el.TotalPrice);
            el.AccountDate = moment(el.AccountDate).format("YYYY-MM-DD");
          });
          item.total = total.toFixed(2);

          if (item.OrderStatus == 2) {
            this.isShowCancel = false;
          }
          item.CheckInTime = moment(item.CheckInTime).format(
            "YYYY-MM-DD HH:mm",
          );
          item.CheckOutTime = moment(item.CheckOutTime).format(
            "YYYY-MM-DD HH:mm",
          );
          item.diffDay =
            moment(item.CheckOutDate).diff(moment(item.CheckInDate), "d") == 0
              ? 1
              : moment(item.CheckOutDate).diff(moment(item.CheckInDate), "d");
        });
        //是否显示修改
        if (
          (res.Data.Status == 0 || res.Data.Status == 1) &&
          res.Data.AntiSettleMark == 0
        ) {
          this.isShowEdit = true;
        }
        // if (res.Data.HasContacted) {
        //   this.contactIcon = "star";
        // }
      });
    },
    // ContactGuest(value) {
    //   let params = {
    //     Id: this.orderId,
    //     HasContacted: !value
    //   };
    //   groupOrderApi.editOrderInfo(params).then(() => {
    //     if (value) {
    //       this.contactIcon = "star-o";
    //       Notify("未联系客人");
    //     } else {
    //       this.contactIcon = "star";
    //       Notify("已联系客人");
    //     }
    //     this.orderInfo.HasContacted = !value;
    //   });
    // },
    onCall(phone) {
      Dialog.confirm({
        title: "拨打订单用户电话",
        message: "是否拨打用户电话" + phone,
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + phone;
        })
        .catch(() => {
          // on cancel
        });
    },

    updateOrder() {
      const roomInfo = cloneDeep(this.orderInfo);
      roomInfo.actionType = "update";
      roomInfo.jumpToName = "groupOrderDetail";
      roomInfo.CompanyId = this.companyId;
      this.setRoomInfo(roomInfo);
      jump("groupRoomOrder", { id: this.orderId });
    },
    orderCancle() {
      Dialog.confirm({
        title: "取消订单",
        message: "确定要取消订单吗？取消后可以通过恢复功能进行复原",
      }).then(() => {
        groupOrderApi.GroupOrderCancel(this.params).then(() => {
          Notify({ type: "success", message: "取消订单成功" });
          this.getOrderDetail();
        });
      });
    },
    orderRecover() {
      Dialog.confirm({
        title: "恢复订单",
        message: "确定要恢复订单吗？",
      }).then(() => {
        groupOrderApi
          .GroupOrderRecover({
            OrderId: this.orderId,
            CompanyId: this.companyId,
          })
          .then(() => {
            Notify({ type: "success", message: "恢复订单成功" });
            this.getOrderDetail();
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 0.3rem;
  font-size: 13px;
  color: #999;
  border-bottom: 3px solid #f5f5f9;
  background-color: white;
  .van-row {
    padding: 3px 0;
  }
  .title {
    font-size: 14px;
    font-size: 0.37333rem;
    background: #f2f9ff;
    padding-left: 3px;
    color: #555;
  }
  .amount {
    text-align: right;
    font-size: 12px;
    color: #666;
    .amountColor {
      color: red;
      font-size: 14px;
    }
  }
  .contact {
    font-size: 16px;
    color: #555;
    span {
      font-size: 14px;
      margin-left: 10px;
      color: #999;
    }
    .address {
      color: #009a4a;
    }
  }
  .remark {
    font-size: 12px;
  }
}
.text-right {
  text-align: center;
}
.info-box {
  .room-item {
    line-height: 22px;
    height: auto;
    .name {
      font-size: 16px;
      color: #555;
    }
    .status {
      color: #008eff;
      text-align: right;
    }
  }
}
.check-date {
  font-size: 12px;
}
.consume-detail {
  /deep/.van-cell {
    padding: 0;
    &:not(:last-child)::after {
      left: 0;
    }
  }
  /deep/.van-collapse-item__content {
    padding: 0;
  }
  /deep/.van-collapse-item__title {
    background: #f2f2f2;
    padding-left: 5px;
  }
  table {
    width: 100%;
    font-size: 12px;
    text-align: left;
    th {
      font-weight: normal;
      background: #09a8d1;
      color: #fff;
      text-align: center;
    }
    td {
      padding: 1px;
    }
  }
}
.pay-detail {
  /deep/.van-collapse-item__title {
    background: #f2f9ff;
    padding-left: 3px;
  }
}
.contacted {
  color: #008eff;
}
/deep/.van-dropdown-menu__title {
  font-weight: bold;
  &::after {
    display: none;
  }
}
.order-drop-menu {
  /deep/ .van-icon {
    color: #868789;
  }
}
.room-content {
  margin-bottom: 5px;
  border-bottom: 1px solid #f4f4f4;
  &:last-child {
    border-bottom: 0;
  }
}
</style>
